// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // ✅ Make sure this matches the file name (App.js with a capital A)
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
